var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-sm-10"},[_c('Files',{attrs:{"spinner":false}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }